/* Christmas 2026 behaviours: snow, reveals, unwrapping gift cards. Pauses off-screen, respects reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- snow canvas ---- */
  function snow(cv, count) {
    var ctx = cv.getContext('2d'), w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), flakes = [], on = true, raf;
    function size() { var r = cv.getBoundingClientRect(); w = r.width; h = r.height; cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function mk(y) { return { x: Math.random() * w, y: y == null ? Math.random() * h : y, r: Math.random() * 2.6 + .8, s: Math.random() * .7 + .35, d: Math.random() * 1.6 - .8, o: Math.random() * .5 + .5, p: Math.random() * 6.28 }; }
    size(); for (var i = 0; i < count; i++) flakes.push(mk());
    function step() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i]; f.p += .01; f.y += f.s; f.x += f.d * .3 + Math.sin(f.p) * .35;
        if (f.y > h + 4) { flakes[i] = mk(-4); continue; }
        if (f.x > w + 4) f.x = -4; if (f.x < -4) f.x = w + 4;
        ctx.globalAlpha = f.o; ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fillStyle = '#fff'; ctx.fill();
      }
      if (on) raf = requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { on = e.isIntersecting; cancelAnimationFrame(raf); if (on) raf = requestAnimationFrame(step); }); }).observe(cv);
    } else { raf = requestAnimationFrame(step); }
    window.addEventListener('resize', function () { size(); });
  }

  function init() {
    if (!reduce) {
      document.querySelectorAll('canvas[data-xm-snow]').forEach(function (cv) { snow(cv, +cv.getAttribute('data-xm-snow') || 60); });
      /* light snow on every other page */
      if (!document.querySelector('[data-xm-home]')) {
        var g = document.createElement('canvas'); g.className = 'xm-gsnow'; g.setAttribute('aria-hidden', 'true'); document.body.appendChild(g); snow(g, window.innerWidth < 700 ? 22 : 40);
      }
    }
    /* reveal + unwrap */
    var cards = document.querySelectorAll('.xm-card');
    if (!reduce) cards.forEach(function (c) { c.classList.add('is-wrapped'); });
    var els = document.querySelectorAll('.xm-rv');
    function show(el) {
      el.classList.add('is-in');
      if (el.classList.contains('xm-card')) { var d = parseInt(getComputedStyle(el).getPropertyValue('--d')) || 0; setTimeout(function () { el.classList.remove('is-wrapped'); }, 650 + d); }
    }
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(show); cards.forEach(function (c) { c.classList.remove('is-wrapped'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
